<template>
  <div class="consents-checkboxes">
    <div 
      v-for="consent in consentsList" 
      :key="consent.name"
      class="flex text-xs mt-5" 
      :class="{ 'input-has-error': getError(consent.name) }"
    >
      <input 
        :id="consent.name"
        :name="consent.name"
        v-model="selectedConsents[consent.name]"
        class="bg-gray-50 border-gray-300 rounded"
        type="checkbox"
        :required="consent.required"
        @change="handleConsentChange(consent.name, $event.target.checked)"
      />
      <label :for="consent.name" class="pl-3.5">
        <span v-html="consent.label"></span>
        <span v-if="consent.required" class="text-red-500 ml-1">*</span>
      </label>
    </div>
    
    <!-- Validation error message -->
    <div v-if="showValidationError" class="mt-4 p-3 bg-red-50 border border-red-200 rounded text-red-600 text-sm">
      <i class="fa fa-exclamation-circle mr-2"></i>
      Please review and accept the required consents before proceeding to the next step.
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConsentsCheckBoxes',
  
  props: {
    errors: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      showValidationError: false,
      selectedConsents: {
        electronic_consent_check: false,
        agree_marketing_sms: false,
        agree_account_sms: false,
        service_check: false
      },
      consentsList: [
        {
          name: "electronic_consent_check",
          required: true,
          label: `I consent to the <a class="text-black text-xs" href="${this.$root.app.electronic_consent_url}" target="_blank">Electronic Communications Consent Policy</a>.`
        },
        {
          name: "agree_marketing_sms",
          required: false,
          label: "I agree to receive marketing SMS messages."
        },
        {
          name: "agree_account_sms",
          required: true,
          label: "I agree to receive loan application and account related SMS messages."
        },
        {
          name: "service_check",
          required: true,
          label: "I am not a Servicemember on active duty with the U.S. military, the U.S. military reserve or the National Guard, nor do I anticipate being called to active duty, nor am I a dependent of a U.S. Servicemember on active duty or anticipated active duty."
        }
      ]
    }
  },

  computed: {
    allRequiredChecked() {
      const requiredConsents = this.consentsList.filter(consent => consent.required);
      const isValid = requiredConsents.every(consent => 
        this.selectedConsents[consent.name] === true
      );
      
      // Emit the validation state to parent
      this.$emit('validation-changed', isValid);
      
      return isValid;
    }
  },

  watch: {
    selectedConsents: {
      handler() {
        // Trigger the computed property
        this.allRequiredChecked;
      },
      deep: true
    }
  },

  methods: {
    getError(fieldName) {
      return this.errors[fieldName];
    },

    handleConsentChange(consentName, isChecked) {
      this.selectedConsents[consentName] = isChecked;
      // Hide error message when user makes changes
      if (this.showValidationError) {
        this.hideError();
      }
    },

    getConsentsData() {
      return { ...this.selectedConsents };
    },

    showError() {
      this.showValidationError = true;
    },

    hideError() {
      this.showValidationError = false;
    }
  }
}
</script>
